<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="space-around" class="text-center">
			<v-col>
				<br />
				<p class="body-1">
					Click
					<!-- Todo, add Ply -><- Crisp icons -->
					<a :href="installationUrl"> here</a>
					to install the Ply plugin for Crisp and to connect your Crisp account to Ply <br /><small style="color: #a8a8a8"
						>If already installed, click <a :href="redirect" draggable="false" class="my-3">here</a> to connect your Crisp account to
						Ply</small
					>
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PreProfileConnectCrisp',
	props: { redirect: { type: String } },
	computed: {
		installationUrl() {
			const pluginId = new URL(this.$props.redirect).searchParams.get('plugin_id');
			return `https://app.crisp.chat/initiate/plugin/${pluginId}/`;
		},
	},
};
</script>

<style scoped lang="scss"></style>
